import { FC } from 'react';
import { Divider, Form, Input } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { SiteReportBusinessActivity } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';
import { useModals } from '@/components/modals/ModalProvider';
import { FleetFile } from '@/libs/fleet-api/fetcher';

type SiteReportBusinessActivityForm = SiteReportBusinessActivity<'payload'> &
	Pick<SiteReportBusinessActivity, 'supportingDocument'>;

const FBDHSiteVisitReportActivity: FC = () => {
	const { openPreviewModal } = useModals();
	const { siteReport, surveyInformation } = useFBDHVisitReportApprovalPage();
	const { form, value, fieldName } = useForm<SiteReportBusinessActivityForm>();

	return (
		<Form
			{...ANTD_DEFAULT_PROPS.FORM}
			form={form}
			labelCol={{
				span: 10,
			}}
			initialValues={
				{
					id: siteReport?.id,
					surveyId: surveyInformation!.id,
					businessActivityVerification:
						siteReport?.businessActivityVerification,
					productionDataVsTargetVerification:
						siteReport?.productionDataVsTargetVerification,
					operationalConstraintsExplanation:
						siteReport?.operationalConstraintsExplanation,
					additionalBusinessActivityInfo:
						siteReport?.additionalBusinessActivityInfo,
					supportingDocument: siteReport?.supportingDocument,
				} as SiteReportBusinessActivityForm
			}
		>
			<Form.Item
				name={fieldName('id')}
				noStyle
			/>
			<Form.Item
				name={fieldName('surveyId')}
				noStyle
			/>
			<Form.Item
				name={fieldName('businessActivityVerification')}
				label="Verifikasi Aktivitas Usaha"
				labelCol={{
					span: 6,
				}}
			>
				<Input.TextArea
					rows={4}
					disabled
				/>
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('productionDataVsTargetVerification')}
				label="Verifikasi Data Produksi vs Target"
				labelCol={{
					span: 6,
				}}
			>
				<Input.TextArea
					rows={4}
					disabled
				/>
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('operationalConstraintsExplanation')}
				label="Penjelasan Hambatan Operasional"
				labelCol={{
					span: 6,
				}}
			>
				<Input.TextArea
					rows={4}
					disabled
				/>
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('additionalBusinessActivityInfo')}
				label="Informasi Lainnya"
				labelCol={{
					span: 6,
				}}
			>
				<Input.TextArea
					rows={4}
					disabled
				/>
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('supportingDocument')}
				label="Upload Dokumen Pendukung"
				labelCol={{ span: 6 }}
			>
				{value?.supportingDocument ? (
					<a
						href="#"
						onClick={(e) => {
							e.preventDefault();
							openPreviewModal(
								value.supportingDocument as unknown as FleetFile,
							);
							// openDocumentModal([
							// 	{
							// 		name: value.supportingDocument!.name,
							// 		type: getDocumentType(value.supportingDocument!.name)!,
							// 		url: value.supportingDocument!.url,
							// 	},
							// ]);
						}}
					>
						{value.supportingDocument?.name}
					</a>
				) : (
					'-'
				)}
			</Form.Item>
		</Form>
	);
};

export default FBDHSiteVisitReportActivity;
